import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation('notFound');

  return (
    <Box className="not-found">
      <Box className="image-container"></Box>
      <Typography>{t('dataNotAvailable')}</Typography>
      <Typography component="span">{t('pageNotFound')}</Typography>
    </Box>
  );
}
